module.exports = __webpack_public_path__ + "img/menu13.7a6df2fa.png";